import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';
import { StyledTextField } from 'modules/components/layer01';
import { useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';
import { SaveDailyReport_Input } from 'generated/graphql';
import { DateTime } from 'luxon';

export type SaveDailyReportFormProps = {
  id: string;
  projectId: string;
  handleClose: () => void;
};

export const FC = (props: SaveDailyReportFormProps) => {
  const navigate = useNavigate();
  const [
    fnSaveDailyReportForm,
    { loading }
  ] = ds.useSaveDailyReport();

  const form = ds.useFormState(props.id, props.projectId);
  const handleSubmit = async (input: SaveDailyReport_Input) => {
    const resp = await fnSaveDailyReportForm(input);
    if (props.id === '') {
      navigate(`${resp.data?.saveDailyReport?.id}`);
    }
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit({
          id: form.formState.id,
          description: form.formState.description,
          projectId: form.formState.projectId,
          reportDate: DateTime.fromISO(DateTime.fromFormat(form.formState.reportDate, 'yyyy-LL-dd').toISODate() ?? '')
        });
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <Stack
        direction='column'
        rowGap='1.5rem'
      >

        <StyledTextField.FC
          {...form.genFieldProps('description')}
          multiline={true}
        />

        <StyledTextField.FC
          {...form.genFieldProps('reportDate')}
        />

      </Stack>
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
